import ManualSection from '../ManualSection';

/**
 * Placeholder manual section shipped with the framework (TRIL-424) to prove the
 * mechanism end-to-end: it is registered, listed on the index, reachable at
 * `/readme/about`, and dogfoods the `#<sub>` auto-expand via its two
 * expandables. Real content sections are their own stories (vouching → TRIL-422,
 * story-analysis → TRIL-425).
 */
export default function AboutManual() {
  return (
    <>
      <p className="MANUAL__LEAD">
        This is the trilirivos manual. It explains the subtler mechanics of the
        app in depth — the parts a one-line tooltip can&apos;t cover. It&apos;s
        here for people already using the app; the pitch for <em>why</em> you
        would want in lives on the marketing site, not here.
      </p>

      <ManualSection id="what" title="What you'll find here" defaultOpen>
        <p>
          Focused guides to features whose mechanics genuinely need explaining —
          things like vouching, the story-analysis flow, and reputation. Each
          one gets its own page, reachable from a small help icon on the feature
          itself. You can also browse them all from this manual&apos;s index.
        </p>
      </ManualSection>

      <ManualSection id="deep-links" title="How deep-links work">
        <p>
          A help icon links straight to the relevant page — and sometimes to a
          specific part of it, which opens and scrolls into view automatically.
          This section is a live example: if you arrived here from a link ending
          in <code>#deep-links</code>, it opened on its own.
        </p>
      </ManualSection>
    </>
  );
}
